import { logException } from '../sentry/logException';

import { ReportingLinesClient } from './ReportingLinesClient';

const _default_1: ReportingLinesClient = new ReportingLinesClient({ logException });

export default _default_1;
